import { type FC } from 'react';
import type { Address } from 'types/common';
import styles from './BillingAddress.module.css';

interface BillingAddressProps {
  address: Address;
}

const BillingAddress: FC<BillingAddressProps> = ({
  address: { name, line1, line2, city, state, zip, country },
}) => (
  <div className={styles.address}>
    <span>{name}</span>
    <span>{line1}</span>
    <span>{line2}</span>
    <span>
      {city}, {state} {zip}
    </span>
    <span>{country}</span>
  </div>
);

export default BillingAddress;
